var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c(
        "span",
        {
          class: [
            _vm.bemElement("text"),
            {
              "visually-hidden": _vm.isBreakpointMobile
            }
          ]
        },
        [_vm._v(_vm._s(_vm.$msg("productList.columns.legend", "productList")))]
      ),
      _vm._v(" "),
      _vm._l(_vm.columnModes, function(value) {
        return [
          _c(
            "button",
            {
              key: "plp-column-mode-button-" + value,
              class: [
                _vm.bemElement("mode", {
                  selected: _vm.isColumnModeSelected(value)
                }),
                "u-btn-clean",
                "interaction--enabled-hover-v1"
              ],
              attrs: { "aria-label": _vm.getColumnModeName(value) },
              on: {
                click: function($event) {
                  return _vm.handleColumnModeClick(value)
                }
              }
            },
            [
              _vm.isBreakpointMobile
                ? [
                    _c("i", {
                      class: [
                        "icon-cols-" + _vm.getNumColumns(value),
                        {
                          "is-selected": _vm.isColumnModeSelected(value)
                        }
                      ]
                    }),
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v(_vm._s(_vm.getNumColumns(value)))
                    ])
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getNumColumns(value)) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }